// Import model
import { ChildLineItem } from '../models/ChildLineItem';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { OtgMeasurement } from '../models/OtgMeasurement';

// Import dependency serializers (for complex types)
import { OtgMeasurementSerializer } from './OtgMeasurementSerializer';

// Import derived type serializers (for polymorphic deserialization)
import { LineItemSerializer } from './LineItemSerializer';

/**
 * Serializer for ChildLineItem - handles JSON serialization and deserialization with type validation
 */
export class ChildLineItemSerializer {
  /**
   * Deserializes a JSON string into a ChildLineItem instance
   */
  static deserialize(json: string): ChildLineItem {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ChildLineItem instance
   */
  static fromObject(obj: any): ChildLineItem {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ChildLineItem');
    }


    const instance: ChildLineItem = {
      description: obj['description'] as string | undefined,
      name: obj['name'] as string | undefined,
      quantity: obj['quantity'] ? OtgMeasurementSerializer.fromObject(obj['quantity']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ChildLineItem instances
   */
  static deserializeArray(json: string): ChildLineItem[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ChildLineItem instance to a JSON string
   */
  static serialize(instance: ChildLineItem): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ChildLineItem instance to a plain object
   */
  static toObject(instance: ChildLineItem): any {
    return {
      'description': instance.description,
      'name': instance.name,
      'quantity': instance.quantity ? OtgMeasurementSerializer.toObject(instance.quantity) : undefined,
    };
  }

  /**
   * Serializes an array of ChildLineItem instances to a JSON string
   */
  static serializeArray(instances: ChildLineItem[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
